export function selectCrossDeviceRequest(state) {
  return state.crossDeviceRequest;
}

export function isCrossDeviceRequestMode(state) {
  return state.crossDeviceRequest != null;
}

function filterMapByDocumentId(map, documentId) {
  if (!map) {
    return map;
  }

  const value = map.get(documentId);
  return value !== undefined ? new Map([[documentId, value]]) : new Map();
}

export function narrowPreparedStateInputsForCrossDevice(inputs) {
  const { crossDeviceRequest, requestedDocuments } = inputs;

  if (!crossDeviceRequest || !requestedDocuments) {
    return inputs;
  }

  const documentId = crossDeviceRequest.documentId;
  const crossDeviceDocument = requestedDocuments.get(documentId);

  if (!crossDeviceDocument) {
    return inputs;
  }

  return {
    ...inputs,
    requestedDocuments: new Map([[documentId, crossDeviceDocument]]),
    documentConditions: [],
    requestPages: null,
    forms: filterMapByDocumentId(inputs.forms, documentId),
    scannedDocuments: filterMapByDocumentId(
      inputs.scannedDocuments,
      documentId
    ),
    documentsStatus: filterMapByDocumentId(inputs.documentsStatus, documentId)
  };
}
